import React from 'react'
import PropTypes from 'prop-types'
// https://icons8.com/line-awesome
import LineAwesome from 'react-line-awesome-svg/components/line-awesome'
import EnvelopeSolid from 'react-line-awesome-svg/icons/EnvelopeSolid'
import PhoneSolid from 'react-line-awesome-svg/icons/PhoneSolid'
import './styles.scss'

const LandingpageHeader = ({
  globals: { logo },
  menus: { contact_page, telephone, telephone_txt },
}) => {
  return (
    <>
      <header className="landingpage">
        <a href={logo.link} className="logo">
          <img width="115" height="20" src={logo.src} alt="" />
        </a>
        <ul>
          {telephone && (
            <li className="phone">
              <a href={`tel:${telephone}`}>
                <LineAwesome icon={PhoneSolid} />
                <span className="phoneText">
                  <span>{telephone_txt}</span>
                </span>
              </a>
            </li>
          )}
          {contact_page && (
            <li className="contact">
              <a
                href={contact_page}
                onClick={e => {
                  const form = document.querySelector('[id^=gform_wrapper_]')
                  if (form) {
                    form.style.scrollMargin = '150px'
                    form.scrollIntoView(true)
                    e.preventDefault()
                  }
                }}
              >
                <LineAwesome icon={EnvelopeSolid} />
              </a>
            </li>
          )}
        </ul>
      </header>
    </>
  )
}

LandingpageHeader.propTypes = {
  globals: PropTypes.object,
  menus: PropTypes.object,
}

export default LandingpageHeader
